module.exports = __webpack_public_path__ + "static/ilustracao-seguranca-acesso-b630e62375b0632ed7159bc19d707953.svg";